export const PUBLIC_COLORS = {
  navy: "#0f172a",
  navyBlue: "#0c2a5e",
  blue: "#0072D4",
  blueHover: "#005EB3",
  orange: "#F56242",
  canvas: "#f8fafc",
  canvasTint: "#eef5ff",
  surface: "#ffffff",
  ink: "#172033",
  muted: "#5f6b7a",
  border: "#dce3ea",
};

export const PUBLIC_PAGE_BACKGROUND =
  "linear-gradient(180deg, #eef5ff 0%, #f8fafc 28%, #f8fafc 100%)";

export const PUBLIC_BRAND_BACKGROUND =
  "linear-gradient(145deg, #0f172a 0%, #0c2a5e 58%, #0f172a 100%)";

export const publicSurfaceSx = {
  backgroundColor: PUBLIC_COLORS.surface,
  border: `1px solid ${PUBLIC_COLORS.border}`,
  borderRadius: "16px",
  boxShadow: "0 16px 40px rgba(15, 23, 42, 0.08)",
};
